/**
 * 403 Forbidden Page
 * Displayed when user doesn't have permission to access a resource
 */
import React from 'react';
import { Link } from 'react-router';
import { ShieldX, Home, ArrowLeft } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { useAuth } from '../../contexts/AuthContext';

export function Forbidden() {
  const { user } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-[#050505] p-6">
      <div className="text-center max-w-lg">
        <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-orange-100 dark:bg-orange-500/10 mb-8">
          <ShieldX className="w-12 h-12 text-orange-500 dark:text-orange-400" />
        </div>

        <h1 className="text-7xl font-bold text-gray-900 dark:text-white mb-4">403</h1>
        <h2 className="text-2xl font-semibold text-gray-700 dark:text-gray-300 mb-6">
          Access Forbidden
        </h2>
        <p className="text-gray-500 dark:text-gray-400 mb-4 leading-relaxed">
          You don't have permission to access this page.
        </p>
        {user && (
          <p className="text-sm text-gray-400 dark:text-gray-500 mb-10">
            Your current role: <span className="font-medium">{user.role}</span>
          </p>
        )}

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button asChild variant="outline" className="border-gray-200 dark:border-white/10">
            <Link to="/" className="flex items-center gap-2">
              <ArrowLeft className="w-4 h-4" />
              Go Back
            </Link>
          </Button>
          <Button asChild className="bg-fuchsia-600 hover:bg-fuchsia-700">
            <Link to="/" className="flex items-center gap-2">
              <Home className="w-4 h-4" />
              Dashboard
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Forbidden;
